import DatePicker from "@/components/DatePicker";
import MultiSelect from "@/components/input/MultiSelect";
import SelectFinal from "@/components/input/Select";
import FinalTable from "@/components/table/Table";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { handleFormChange } from "@/utils/formChange";
import { formInterface } from "@/interface/dataInterface";
import { FC, FormEvent } from "react";

const ServiceForm: FC<formInterface> = ({formProp, setFormProp, otherData, setOtherData}) => {
    return (
        <div className="w-full">
            <div className="w-full">
                <div className="grid grid-cols-2 gap-4">
                    <div className="grid gap-1">
                        <Label htmlFor="date" className="text-right">
                            Date *
                        </Label>
                        <DatePicker date={formProp.date} setDate={(e: FormEvent<any>) => handleFormChange(e, setFormProp)} />
                    </div>
                    <div className="grid gap-1">
                        <Label htmlFor="time" className="text-right">
                            Time *
                        </Label>
                        <Input type="time" id="time" value={formProp.time} onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setFormProp)} required />
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-5">
                    <div className="grid gap-1">
                        <div className="grid grid-cols-2 place-items-end gap-x-2">
                            <div className="w-full">
                                <Label htmlFor="vehicle_id" className="text-right">
                                    Select vehicle
                                </Label>
                                <SelectFinal id="vehicle_id" value={formProp.vehicle_id} setValue={(e: FormEvent<HTMLSelectElement>) => handleFormChange(e, setFormProp)} resource="vehicles" dataProp="nickname" />
                            </div>
                            <div className="w-full">
                                <Label htmlFor="odometer" className="text-right">
                            Odometer *
                        </Label>
                        <Input
                            min={0.1}
                            step={0.1}
                            id="odometer"
                            type="number"
                            value={formProp.odometer}
                            placeholder="Odometer" onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setFormProp)}
                        />
                                
                            </div>
                        </div>
                    </div>
                    <div className="grid gap-1">
                            <Label htmlFor="services_type_list" className="text-right">
                                    Select services
                                </Label>
                                <MultiSelect
                                    resource="service-type"
                                    dataProp="name"
                                    selected={otherData || []} 
                                    setSelected={setOtherData || (() => {})}
                                />
                    </div>
                </div>
                <div className="grid gap-4 mt-5">
                    <div className="grid gap-1">
                        <Label htmlFor="notes" className="text-right">
                            Notes
                        </Label>
                        <div className="relative">
                            <Textarea id="notes" value={formProp.notes} onChange={(e: FormEvent<HTMLTextAreaElement>) => handleFormChange(e, setFormProp)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <div className="grid place-items-center gap-y-3 overflow-y-auto">
                    <FinalTable data={otherData || []} setData={setOtherData || (() => {})} />
                </div>
            </div>
        </div>
    )
}

export default ServiceForm;